import { useMemo } from 'react';
import useModularPDPState from '../useModularPDPState';
import { getAllPreconfigProductCustomerPhotosReviews } from './utils';
const useModularPDPCustomerPhotosAndReviews = (id, slug, hookOptions = {}) => {
  const {
    skip = false
  } = hookOptions;
  const {
    data: {
      modularState
    } = {},
    loading: modularLoading
  } = useModularPDPState(id, slug, skip ? {
    skip: true
  } : undefined);
  const customerPhotos = useMemo(() => {
    if (!skip && modularState?.preConfiguredProducts?.length) {
      const {
        customerPhotosList
      } = getAllPreconfigProductCustomerPhotosReviews({
        preConfiguredProducts: modularState.preConfiguredProducts
      });
      return {
        photos: customerPhotosList,
        totalPhotos: customerPhotosList.length
      };
    }
    return {};
  }, [modularState?.preConfiguredProducts, skip]);
  const customerReviews = useMemo(() => {
    if (!skip && modularState?.preConfiguredProducts?.length) {
      const {
        customerReviewsList,
        averageRating
      } = getAllPreconfigProductCustomerPhotosReviews({
        preConfiguredProducts: modularState.preConfiguredProducts
      });
      return {
        reviews: customerReviewsList,
        averageRating,
        totalReviews: customerReviewsList.length
      };
    }
    return {};
  }, [modularState?.preConfiguredProducts, skip]);
  if (skip) {
    return {};
  }
  return {
    loading: modularLoading,
    customer_photos_min: customerPhotos,
    customer_reviews: customerReviews
  };
};
export default useModularPDPCustomerPhotosAndReviews;